/**
 * Router Configuration
 * Splits public invite routes from staff dashboard
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import PublicLayout from './components/public/PublicLayout';
import InviteWelcome from './components/public/InviteWelcome';
import VerifyCode from './components/public/VerifyCode';
import PublicInductionForm from './components/public/PublicInductionForm';
import InductionReview from './components/public/InductionReview';
import SubmissionComplete from './components/public/SubmissionComplete';
import InductionApproved from './components/public/InductionApproved';

/**
 * Public Routes - Contractor invite flow
 * No authentication required
 */
export function PublicRoutes() {
  return (
    <Routes>
      <Route path="/i" element={<PublicLayout />}>
        <Route index element={<InviteWelcome />} />
        <Route path="verify" element={<VerifyCode />} />
        <Route path="induction" element={<PublicInductionForm />} />
        <Route path="review" element={<InductionReview />} />
        <Route path="complete" element={<SubmissionComplete />} />
        <Route path="approved" element={<InductionApproved />} />
      </Route>
      <Route path="/i/:token" element={<PublicLayout />}>
        <Route index element={<InviteWelcome />} />
        <Route path="verify" element={<VerifyCode />} />
        <Route path="induction" element={<PublicInductionForm />} />
        <Route path="review" element={<InductionReview />} />
        <Route path="complete" element={<SubmissionComplete />} />
        <Route path="approved" element={<InductionApproved />} />
      </Route>
      <Route path="/i/:token/*" element={<Navigate to="/i/:token" replace />} />
      <Route path="/i/*" element={<Navigate to="/i" replace />} />
    </Routes>
  );
}
